var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiteIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M13.895,20.211a21.865,21.865,0,0,0,1.5,2.526H2.526A2.526,2.526,0,0,1,0,20.211V2.526A2.526,2.526,0,0,1,2.526,0H20.211a2.526,2.526,0,0,1,2.526,2.526V9.638a6.455,6.455,0,0,0-2.526-.8V2.526H2.526V20.211H13.895m0-8.476-3.524,4.472L7.844,13.225,4.421,17.684h8.488a7.579,7.579,0,0,1-.278-1.895,6.947,6.947,0,0,1,1.263-3.954v-.1M24,15.789C24,19.074,19.579,24,19.579,24s-4.421-4.926-4.421-8.211a4.421,4.421,0,1,1,8.842,0m-2.905.126A1.629,1.629,0,0,0,19.579,14.4a1.516,1.516,0,1,0,0,3.032,1.453,1.453,0,0,0,1.516-1.516Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteIconWhite);
export default __webpack_public_path__ + "static/media/Site-Icon-White.a0ebf2957c838b89b9d27d99d3a0acfb.svg";
export { ForwardRef as ReactComponent };